app.controller("StudentNewProfileController", [
    "$scope", "Students", "$uibModal", "FreshModal", "AuthService", "ProgramService", "StaticData", "UserConfigService", "$state",
    function ($scope, Students, $uibModal, FreshModal, AuthService, ProgramService, StaticData, UserConfigService, $state) {
        $scope.disabled = true;
        AuthService.getProfiles().then(function (profiles) {
            var currentStudent = _.find(profiles, {type: 'student', state: 'active'});
            if (!currentStudent) currentStudent = _.find(profiles, {type: 'student'});
            ProgramService.fetchOne(currentStudent.program).then(function (program) {
                $scope.program = program;
            });
            return $scope.student = currentStudent;
        });

        $scope.getUserData = function () {
            AuthService.getUserData().then(function (user) {
                $scope.user = user;
                $scope.disabled = false;
            });
        };

        $scope.getUserData();


        StaticData.getItemsByKey("grant_types").then(function (grantTypes) {
            $scope.grantTypes = grantTypes;
            $scope.grantTypesMap = _.keyBy($scope.grantTypes, '_id');
        });

        $scope.changeImage = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            FreshModal.open({
                controller: "alertWindowController",
                templateUrl: _pb + 'student-new/alert-window.html',
                resolve: {}
            }).then(function (result) {

            }, function (result) {

            });
        };

        $scope.changePhone = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            FreshModal.open({
                component: "studentChangePhoneModalComponent",
                backdrop: 'static',
                keyboard: false
            }).then(function () {
                $scope.getUserData();
            }, function () {
            });
        };

        $scope.changePassword = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            FreshModal.open({
                component: "studentChangePasswordModalComponent",
                backdrop: 'static',
                keyboard: false
            }).then(function () {
            }, function () {
            });
        };

        $scope.changeMail = function () {
            $state.go('change-mail', { profile: 'student' });
        };

        $scope.changeNotificationSettings = function () {
            $scope.disabled = true;
            var newValue = !$scope.user.userConfig.notifyOnMail;
            console.log(newValue)
            UserConfigService.set({key: 'notifyOnMail', value: newValue}).then(function () {
                $scope.user.userConfig.notifyOnMail = newValue;
                console.log($scope.user)
                $scope.disabled = false;
            });
        }
    }
]);
